import { CModal } from '@coreui/react';
import styled from 'styled-components';

export const AddProductsModalWrapper = styled(CModal)`
  & > div.modal-dialog > div.modal-content {
    width: 1450px;
  }
`;
